import {getCurrentYear} from '../../utils/commons'
import BestPatrioticPicksLogo from './logo'
import {bestPatrioticPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestpatrioticpicks' as const,
  domainType: 'maga' as const,
  siteName: 'Best Patriotic Picks',
  logo: <BestPatrioticPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/bestpatrioticpicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-F0MBH6YSSB',
    camelCaseUrl: 'BestPatrioticPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | BestPatrioticPicks.com – Trusted Reviews & Guides`,
    description: (_category?: string, _count?: string) =>
      `Discover the most trusted product picks for Americans at BestPatrioticPicks.com. Our expert reviews spotlight reliable gear and gadgets that reflect strong patriotic value.`,
    styles: bestPatrioticPicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
